import React, { useContext, useEffect, useState, useRef } from "react";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import { useTheme } from "../../context/ThemeContext";
import { useQuery } from "@tanstack/react-query";
import Table from "../../components/Table.jsx";
import RowTeamAgentInsight from "./RowTeamAgentInsight.jsx";
import ChartTeamAgentInsight from "./ChartTeamAgentInsight.jsx";
import { AgentInsightcolumns, TicketsInsightcolumns } from "../../components/headerContent";
import AgentInsightHistory from './AgentInsightHistory.jsx'
import { useLocation, Link } from "react-router-dom";
import NumberCard from "../../components/Card/NumberCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import Loader from "../../components/Loader";
import { useTranslation } from "react-i18next";

export default function AgentInsight() {
    const { apiUrl, user } = useContext(AuthContext);
    const { theme } = useTheme();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const agentId = searchParams.get("agentId");
    const [teamArray, setTeamArray] = useState([]);
    const [ticketsClicked, setTicketsClicked] = useState([]);
    const [ticketsByAgents, setTicketsByAgents] = useState({});
    const [ticketsFiltered, setTicketsFiltered] = useState([]);
    const [nameAgent, setNameAgent] = useState();
    const { t } = useTranslation();

    const getHaloTeams = async () => {
        const res = await axios.get(`${apiUrl}halo`, {
            withCredentials: true
        });
        return res.data;
    };

    const haloTeams = useQuery({
        queryKey: ["haloTeams"],
        queryFn: getHaloTeams
    });

    useEffect(() => {
        if (agentId && haloTeams.data) {
            const updatedTeams = haloTeams.data
                .filter(team =>
                    team.agents.some(agent => parseInt(agent.agent_id, 10) === parseInt(agentId, 10))
                )
                .map(team => team.name);

            setTeamArray(updatedTeams);
        }
    }, [agentId, haloTeams.data]);

    useEffect(() => {
        if (ticketsByAgents.length > 0 && ticketsClicked) {
            const filteredTickets = ticketsByAgents
                .filter(agent => agent.day === ticketsClicked.day) // Trouver le jour
                .flatMap(agent => agent.tickets) // Extraire les tickets pour ce jour
                .filter(ticket => ticket.team === ticketsClicked.groupements); // Filtrer par team
            setTicketsFiltered(filteredTickets);
        }
    }, [ticketsByAgents, ticketsClicked]);

    if (!haloTeams.isLoading && haloTeams.data === undefined || !haloTeams.isLoading && haloTeams.data.length === 0) {
        return (
            <div className="ecp-container">
                <div className="ecp-container-content-error">
                    <div className="error-container">
                        <img src='../assets/ecp_error.svg' alt="icône d'erreur" />
                        <div className="error-container-text">
                            <h1 className="page-title">
                                {t("Aucune données disponible")}
                            </h1>
                            <p className="page-link_home">
                                <Link to="/"> {t("Revenir à l'accueil")}</Link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="ecp-container">
            <div className="ecp-container-content">
                <section className="agent-insight">
                    {haloTeams.data ? (
                        <>
                            <div className="ecp-container-content-header">
                                <div className="ecp-container-content-header-title">
                                    <div className="page-title page-logo">
                                        <h1 className="page-title agent-insight-title">
                                            {ticketsClicked.day || ticketsClicked.groupements ? t("Statistiques des tickets de l'agent") :
                                                agentId && teamArray ? t("Statistiques de l'agent") :
                                                    t('Statistiques des agents')
                                            }
                                            <span> {agentId && teamArray && nameAgent}</span>
                                        </h1>
                                    </div>
                                </div>
                            </div>
                            {ticketsFiltered.length > 0 && (
                                <section className="page-section">
                                    <NumberCard
                                        title={`${t("Tickets")}`}
                                        number={
                                            ticketsFiltered ? ticketsFiltered.length : null
                                        }
                                        logo={faCircleCheck}
                                        color={"#AEC353"}
                                        stylesIcons={"logo-certificats"}
                                    />
                                </section>
                            )}
                            {agentId && teamArray ? (
                                <>
                                    {ticketsClicked.day || ticketsClicked.groupements ? (
                                        <>
                                            <div className="mb-1">
                                                <a onClick={() => setTicketsClicked({})} className="buttons-ecp button-new"><FontAwesomeIcon icon={faChevronLeft} /> {t('Retour')}</a>
                                            </div>
                                            <div>
                                                {ticketsFiltered && <Table tableData={ticketsFiltered} tableColumns={TicketsInsightcolumns} />}
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div className="mt-1">
                                                <Link to={`/agentinsight`} className="buttons-ecp button-new"><FontAwesomeIcon icon={faChevronLeft} /> {t('Retour')}</Link>
                                            </div>
                                            <div>
                                                <AgentInsightHistory data={haloTeams.data} agentId={agentId} teamArray={teamArray} setTicketsByAgents={setTicketsByAgents} setTicketsClicked={setTicketsClicked} setNameAgent={setNameAgent} theme={theme} />
                                            </div>
                                        </>
                                    )}

                                </>
                            ) : (
                                <>
                                    <div>
                                        <ChartTeamAgentInsight data={haloTeams.data} theme={theme} />
                                    </div>
                                    {haloTeams.data &&
                                        <div className='cato-content-table'>
                                            <Table tableData={haloTeams.data} tableColumns={AgentInsightcolumns} rowComponent={RowTeamAgentInsight} />
                                        </div>
                                    }
                                </>

                            )}
                        </>
                    ) : (
                        <Loader />
                    )}
                </section>
            </div>
        </div>
    )
}